import type { JSX } from 'react';
import { useRef } from 'react';
import { DraggableBlockPlugin_EXPERIMENTAL } from '@lexical/react/LexicalDraggableBlockPlugin';

const DRAGGABLE_BLOCK_MENU_CLASSNAME = 'draggable-block-menu';

function isOnMenu(element: HTMLElement): boolean {
  const isDecorator = element.getAttribute('data-lexical-decorator') === 'true';
  if (!isDecorator) {
    return false;
  }
  return !!element.closest(`.${DRAGGABLE_BLOCK_MENU_CLASSNAME}`);
}

export default function DraggableBlockPlugin({
  anchorElem = document.body,
}: {
  anchorElem?: HTMLElement;
}): JSX.Element {
  const menuRef = useRef<HTMLDivElement>(null);
  const targetLineRef = useRef<HTMLDivElement>(null);

  return (
    <DraggableBlockPlugin_EXPERIMENTAL
      anchorElem={anchorElem}
      isOnMenu={isOnMenu}
      menuComponent={
        <div
          ref={menuRef}
          className={`
            ${DRAGGABLE_BLOCK_MENU_CLASSNAME}
            rounded
            px-1
            py-1
            cursor-grab
            opacity-0
            absolute
            left-[-12px]
            top-[2px]
            [will-change:transform]
            bg-white
            shadow-sm
            hover:bg-gray-50
            active:cursor-grabbing
          `}>
          <div className="w-[15px] h-[15px] opacity-50 text-gray-600">
            <svg
              className="w-full h-full"
              fill="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M8.5 10a2 2 0 1 0 2 2 2 2 0 0 0-2-2Zm0 7a2 2 0 1 0 2 2 2 2 0 0 0-2-2Zm7-10a2 2 0 1 0-2-2 2 2 0 0 0 2 2Zm-7-4a2 2 0 1 0 2 2 2 2 0 0 0-2-2Zm7 14a2 2 0 1 0 2 2 2 2 0 0 0-2-2Zm0-7a2 2 0 1 0 2 2 2 2 0 0 0-2-2Z"
                stroke="currentColor"
              />
            </svg>
          </div>
        </div>
      }
      menuRef={menuRef}
      targetLineComponent={
        <div
          ref={targetLineRef}
          className="
            pointer-events-none
            bg-[deepskyblue]
            h-1
            absolute
            left-0
            top-0
            opacity-0
            [will-change:transform]
          "
        />
      }
      targetLineRef={targetLineRef}
    />
  );
}
